import { graphql, useStaticQuery } from 'gatsby';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React from 'react';

import Seo from './seo';

const MarketingSeo = ({ meta = {}, slug }) => {
  const { site, siteSettings } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
        siteSettings: contentfulBlogSettings(contentful_id: { eq: "3vxKUCou9H8hWkqL5dcaNm" }) {
          ...SiteSettings
        }
      }
    `
  );

  const pageTitle = get(meta, 'pageTitle') || get(siteSettings, 'pageTitle') || site.siteMetadata.title;
  const metaDescription =
    meta?.metaDescription?.metaDescription ||
    siteSettings?.metaDescription?.metaDescription ||
    site.siteMetadata.description;
  const metaOgImageUrl = get(meta, 'ogImage.file.url') || get(siteSettings, 'ogImage.resize.src', '');
  const metaOgImageTitle = get(meta, 'ogImage.description') || get(meta, 'ogImage.title');
  const isNoFollow = get(meta, 'noFollow');
  return (
    <Seo
      title={pageTitle}
      noFollow={isNoFollow === 'Yes'}
      description={metaDescription}
      ogDescription={meta?.ogMetaDescription?.ogMetaDescription || metaDescription}
      ogTitle={meta?.ogTitle || pageTitle}
      ogImageUrl={metaOgImageUrl}
      ogImageAlt={metaOgImageTitle}
      slug={slug}
    />
  );
};

MarketingSeo.propTypes = {
  meta: PropTypes.shape({
    metaDescription: PropTypes.object,
    pageTitle: PropTypes.string,
    ogImage: PropTypes.object,
  }),
};

export default MarketingSeo;
